import SodActVsPotChip from './SodActVsPotChip';

export default SodActVsPotChip;
